import React, { useEffect, useRef } from "react";

export const AD_CLIENT = "ca-pub-2314372466669749";
export const AD_UNITS = {
  TOP: "8691187777",     // OddlyTrue_Top_Leaderboard
  IN1: "7373227519",     // OddlyTrue_InFeed_1
  MID: "3820995310",     // OddlyTrue_Mid_Rect
  IN2: "3761285567",     // OddlyTrue_InFeed_2
  FOOTER: "7381886249",  // OddlyTrue_Footer_Leaderboard
  MOBILE_SQ: "4145171209",  // OddlyTrue_Mobile_Square
  BIRTHDAYS: "5631486579",  // OddlyTrue_Birthdays_Leaderboard
  SAVED: "5430332713",      // OddlyTrue_Saved_Leaderboard
};

const MIN_H = { leaderboard: "min-h-[90px]", rect336: "min-h-[280px]", rect300: "min-h-[250px]" };
const MAX_W = { leaderboard: "max-w-[970px]", rect336: "max-w-[336px]", rect300: "max-w-[336px]" };

const Placeholder = ({ id, slot, size, className }) => (
  <div id={id} data-testid={id} data-ad-slot={slot}
    className={`adsense-box w-full mx-auto flex items-center justify-center rounded-lg ${MIN_H[size]} ${MAX_W[size]} ${className}`}
    style={{ border: "1px dashed #d1d5db", background: "#f9fafb", padding: 12, textAlign: "center", fontSize: 11, color: "#9ca3af", letterSpacing: "0.12em" }}>
    ADVERTISEMENT
  </div>
);

export const AdSlot = ({ id, slot, size = "leaderboard", className = "" }) => {
  const ref = useRef(null);
  const unit = AD_UNITS[slot];

  useEffect(() => {
    const ins = ref.current;
    if (!unit || !ins || ins.getAttribute("data-adsbygoogle-status")) return;
    try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch (e) { /* blocked or not loaded yet */ }
  }, [unit]);

  if (!unit) return <Placeholder id={id} slot={slot} size={size} className={className} />;
  return (
    <div id={id} data-testid={id} data-ad-slot={slot} className={`adsense-unit w-full mx-auto ${MAX_W[size]} ${className}`}>
      <ins ref={ref} className="adsbygoogle" style={{ display: "block" }} data-ad-client={AD_CLIENT} data-ad-slot={unit} data-ad-format="auto" data-full-width-responsive="true" />
    </div>
  );
};
